<template>
  <content-layout :title="title" :head-image="headImage" :tabs="tabs" v-model="activeTab">
    <div class="table-wrap" slot="lists">
      <div class="table-box" 
        @mouseenter="handleMouseEnter" 
        @mousedown="handleMouseDown" 
        @mouseleave="handleMouseLeave" :class="{'hovering': hovering, 'dragging': dragging}">
          <table class="table" id="tableData">
            <thead>
              <tr drage-off>
                <th width="40px">#</th>
                <th>标题</th>
                <th width="140px">时间</th>
                <th width="60px">排序</th>
                <th width="105px">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in table" :id="item.id" :sort="index" :key="index" class="list-complete-item">
                <td>{{item.id}}</td>
                <td>{{item.title}}</td>
                <td>2018-02-04 00:00:00</td>
                <td><Input v-model="item.sort" @on-blur="sortChange" size="small"></Input></td>
                <td>
                  <Button type="primary" size="small">编辑</Button>
                  <Button type="error" size="small">删除</Button>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-fix" :style="style" id="tableFix" v-show="dragging">
            <thead>
              <tr>
                <td width="40px"></td>
                <td></td>
                <td width="140px"></td>
                <td width="60px"></td>
                <td width="105px"></td>
              </tr>
            </thead>
            <tbody>
            </tbody>
          </table>
      </div>
    </div>
  </content-layout>
</template>


<script>
  let move = 'ontouchmove' in document ? 'touchmove' : 'mousemove'
  let end = 'touchend' in document ? 'touchend' : 'mouseup'

  export default {
    name: 'DemoPage',
    components: {
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    data () {
      return {
        title: 'Table',
        tabs: [
          {'title': 'Table', 'key': 'lists', 'visible': true}
        ],
        activeTab: null,
        headImage: '/static/images/bg/money.jpeg',
        table: [
          {id: 1, title: 'a', sort: 1},
          {id: 2, title: 'b', sort: 22},
          {id: 3, title: 'c', sort: 13},
          {id: 4, title: 'd', sort: 4},
          {id: 5, title: 'e', sort: 5},
          {id: 6, title: 'f', sort: 60},
          {id: 7, title: 'a', sort: 7},
          {id: 8, title: 'a', sort: 88},
          {id: 9, title: 'a', sort: 9},
          {id: 10, title: 'a', sort: 100},
          {id: 11, title: 'a', sort: 11},
          {id: 12, title: 'a', sort: 12},
          {id: 13, title: 'a', sort: 13},
          {id: 14, title: 'a', sort: 4},
          {id: 15, title: 'a', sort: 15},
          {id: 16, title: 'a', sort: 6},
          {id: 17, title: 'a', sort: 17},
          {id: 18, title: 'a', sort: 8},
          {id: 19, title: 'a', sort: 9},
          {id: 20, title: 'a', sort: 20},
          {id: 21, title: 'a', sort: 21}
        ],
        allIds: [],
        direction: null,
        currentTable: null,
        currentNode: null,
        currentInd: 0,
        currentId: 0,
        dragNode: null,
        hovering: false,
        dragging: false,
        dragParams: {
          top: 0,
          left: 0,
          currentX: 0,
          currentY: 0
        },
        style: {
          top: 0,
          left: 0
        }
      }
    },
    mounted () {
      this.table = this.sortList(JSON.parse(JSON.stringify(this.table)))
    },
    // 自定义指令
    directive: {
      drag: {
        bind: function (el, binding) {
          let oDiv = el
          oDiv.onmousedown = function (e) {
            let disX = e.clientX - oDiv.offsetLeft
            let disY = e.clientY - oDiv.offsetTop

            document.onmousemove = function (e) {
              let l = e.clientX - disX
              let t = e.clientY - disY

              oDiv.style.left = l + 'px'
              oDiv.style.top = t + 'px'

              binding.value({
                x: e.pageX,
                y: e.pageY
              })
            }
            document.onmouseup = function () {
              document.onmousemove = null
              document.onmouseup = null
            }
          }
        }
      }
    },
    methods: {
      greet (val) {
        this.val = val
      },
      handleMouseEnter () {
        this.hovering = true
      },
      handleMouseLeave () {
        this.hovering = false
        this.dragging = false
        // this.dragParams.left = this.style.left.replace('px', '', this.style.left)
      },
      sortChange () {
        this.table = this.sortList(JSON.parse(JSON.stringify(this.table)))
      },
      sortList (list) {
        list.sort(function (a, b) {
          return a.sort - b.sort || a.id - b.id
        })
        return list
      },
      handleMouseDown (event) {
        var e = 'touchstart' in document ? event.touches[0] : event
        let tr = e.target.parentNode
        // 限制拖拽对象
        if (tr.getAttribute('drage-off') === '' || tr.tagName !== 'TR') {
          this.dragNode = null
          this.currentTable = null
          return
        }
        this.dragParams.top = tr.offsetTop
        this.dragNode = document.getElementById('tableFix')
        this.currentTable = document.getElementById('tableData')
        this.dragNode.querySelector('tbody').appendChild(tr.cloneNode(true))
        window.addEventListener(move, this.onDragging)
        window.addEventListener(end, this.onDragEnd)
        this.currentNode = tr
        this.currentId = tr.getAttribute('sort')
        // this.currentNode.style.backgroundColor = '#eee'
        this.currentNode.style.visibility = 'hidden'
        // window.addEventListener('contextmenu', this.onDragEnd)
        this.onDragStart(event)
      },
      onDragStart (event) {
        this.dragging = true
        var e = 'touchstart' in document ? event.touches[0] : event
        // var e = event || window.event
        this.dragParams.currentY = e.clientY
      },
      onDragging (event) {
        let e = 'ontouchmove' in document ? event.touches[0] : event
        // let tr = e.target.parentNode
        if (this.dragging) {
          let nowY = e.clientY
          let disY = nowY - this.dragParams.currentY
          let top = parseInt(this.dragParams.top) + disY
          // 移动方向
          this.direction = disY < 0 ? 'up' : 'down'
          this.dragNode.style.top = top + 'px'
          // this.number = (parseInt(top) - 180) / 180
          if (Math.abs(disY) > 1) this.impactTest(this.currentTable.querySelectorAll('tbody>tr'), this.dragNode)

          if (event.preventDefault) {
            event.preventDefault()
          }
          return false
        }
      },
      onDragEnd () {
        if (this.dragging) {
          this.dragging = false
          // this.currentNode.style.backgroundColor = '#fff'
          this.currentNode.style.visibility = 'visible'
          if (this.direction !== null) {
            this.direction = null
            let swapRow = this.table[this.currentInd]
            // let tragetRow = this.table[this.currentId]
            this.$set(this.table[this.currentId], 'sort', swapRow.sort - 1)
          }
          // 当div下还存在子节点时 循环继续
          while (this.dragNode.querySelector('tbody').hasChildNodes()) {
            this.dragNode.querySelector('tbody').removeChild(this.dragNode.querySelector('tbody').firstChild)
          }
          window.removeEventListener(move, this.onDragging)
        }
      },
      impactTest (node, obj) {
        let y = obj.offsetTop + obj.offsetHeight / 2
        if (this.direction === 'down') y = obj.offsetTop + obj.offsetHeight
        for (let k in node) {
          if (node[k].offsetTop < y && node[k].offsetTop + node[k].offsetHeight > y && this.direction === 'up') {
            this.currentInd = k
            this.currentTable.querySelector('tbody').insertBefore(this.currentNode, node[k])
          } else if (node[k].offsetTop < y && node[k].offsetTop + node[k].offsetHeight / 2 > y && this.direction === 'down') {
            this.currentInd = k
            this.currentTable.querySelector('tbody').insertBefore(this.currentNode, node[k])
          }
        }
      }
    }
  }
</script>

<style scoped>
.table-wrap{padding:20px;}
.table-box{position: relative;}
.table{
  width: 100%;
  border-collapse: collapse
}
.hovering tr td{
  cursor: grab
}
.dragging tr td{
  cursor: grabbing
}
.table td,.table thead tr th{
  border: 1px solid #ccc;
  padding: 5px 10px;
}
.table thead tr th{
  background-color: #eee;
  text-align: left
}
.table-fix{position: absolute;top:0;left:0;background-color: #fff;box-shadow: 0 0 6px rgba(0, 0, 0, .5)}
.table-fix thead td{border-top:none;border-left:none;border-right:none;padding:0;}
.list-complete-item {
  transition: all 1s;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to{
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
